import {
  GoogleMap,
  GoogleMapProps,
  useLoadScript,
} from "@react-google-maps/api"
import React from "react"
import mapStyles from "utils/mapStyles"
const libraries = ["drawing", "places", "visualization"] as any

interface CustomMapProps extends GoogleMapProps {
  styles?: any
  loadingElement?: any
  // Added height and width to make it for compatibility
  height?: any
  width?: any
}
const Map = ({
  children,
  styles,
  loadingElement = null,
  ...otherProps
}: CustomMapProps) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
    libraries,
    version: "3.64",
  })

  if (!isLoaded) return loadingElement

  return (
    <GoogleMap
      options={{
        styles,
        ...otherProps.options,
      }}
      {...otherProps}
    >
      {children}
    </GoogleMap>
  )
}
Map.defaultProps = {
  styles: mapStyles,
  mapContainerStyle: {
    width: " 100%",
    height: 400,
  },
}
export default Map
